/**
 * 自定义图片组件，可用于缩略图，以及当没有图片时，需要显示默认图片的情况下
 * src: 图片路径
 * alt: 图片描述（非必传）
 * size: 图片大小（非必传）
 * 当图片不存在或图片加载失败时，会显示默认图片
 *
 * 使用方式 ↓
 * import Image from '@/components/Image
 * <Image src="" alt="" />
 */

import React, { useEffect, useState } from "react";

const Image = ({ src, alt, size, showBorder = true }) => {
  const defaultImage = "/default_image.png";
  const [imageUrl, setImageUrl] = useState(src || defaultImage);

  useEffect(() => {
    setImageUrl(src || defaultImage);
  }, [src]);

  const onError = () => {
    if (src && !src.includes("default_image")) {
      setImageUrl(defaultImage);
    }
  };

  return (
    <div
      style={{
        display: "inline-block",
        width: size ? `${size}px` : `100%`,
        height: size + "px",
        overflow: "hidden",
        // border: showBorder ? "0.1rem solid var(--p-divider)" : "none",
        // borderRadius: showBorder ? "var(--p-border-radius-base)" : 0,
      }}
    >
      <img
        src={imageUrl}
        alt={alt}
        width={size ? `${size}px` : `100%`}
        height={size}
        style={{
          border: showBorder ? "0.1rem solid var(--p-divider)" : "none",
          borderRadius: showBorder ? "var(--p-border-radius-base)" : 0,
          verticalAlign: "middle",
        }}
        onError={onError}
      />
    </div>
  );
};

export default Image;
